import React, { Component } from 'react';
import Lottie from "lottie-react";
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom'
import { Container, Row, Col, Button, Dropdown } from 'react-bootstrap';
import more from '../../../../assets/img/icons/more.svg'
import upload from '../../../../assets/img/icons/upload.svg';
import back from '../../../../assets/img/icons/back.svg';
import axios from 'axios';
import ls from "local-storage";
import loaderjson from '../../../../assets/json/loader.json';
import { Trans } from "react-i18next";   
import "../../../../config/i18n";
import { withTranslation } from "react-i18next";

class EditPhoto extends Component {

    constructor(props) {
        super(props);
        this.onDeleteimage = this.onDeleteimage.bind(this);
        this.onFirstlook = this.onFirstlook.bind(this);
        this.fileInput = React.createRef();
        this.state = {
            selectedFile: null,
            previewImage: null,
            api_url: localStorage.getItem('api_url'),
            langKey: ls.get('LangValue'),
            imagess: [],
            notifymsg: '',
            suc_msg: '',
            errors: {},
            showLoader: 0,
        };
    }

    componentDidMount() {
        if (this.props.i18n.language === 'ar' || this.props.i18n.language === 'he') {
            document.body.dir = 'rtl';
            document.body.classList.add('rtl');
            document.body.classList.remove('ltr')
        } else {
            document.body.dir = 'ltr';
            document.body.classList.remove('rtl');
            document.body.classList.add('ltr');
        }
        
        let data = new FormData();
        data.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
        data.append('language', this.state.langKey);

        axios({
            method: 'post',
            url: this.state.api_url + 'webprofile',
            data: data,
            config: { headers: { 'Content-Type': 'multipart/form-data' } }
        }).then(res => {
            if (res.data.status !== false) {
                const user_details = res.data.result;
                this.setState({
                    user_details: user_details,
                    image: user_details.imagess,
                    imagess: user_details.imagess,
                });
            } else {
                this.props.history.push("/");
            }
        }).catch(error => {
            this.props.history.push("/");
        });
    }

    handleFileChange = (event) => {
        console.log("handleFileChange");
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = (e) => {
                this.setState({
                    selectedFile: file,
                    previewImage: reader.result,
                    showLoader: 1
                });
                // if (this.state.showLoader === 0) {
                    const url = this.state.api_url + 'uploadimageweb';
                    const formData = { file: e.target.result, user_id: JSON.parse(localStorage.getItem('session_userid')), language: this.state.langKey };
                    this.setState({
                        showLoader: 1
                    });
                    return axios.post(url, formData).then(res => {
                        if (res.data.status === 'true') {
                            const image_url = res.data.imageurl;
                            const image_name = res.data.image_name;
                            var editprofile = new FormData();
                            editprofile.set('images', image_url);
                            editprofile.set('images_name', image_name);
                            editprofile.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
                            editprofile.set('language', this.state.langKey);
                            axios({
                                method: 'post',
                                url: this.state.api_url + 'websetprofile',
                                data: editprofile,
                                config: { headers: { 'Content-Type': 'multipart/form-data' } }
                            }).then(res => {
                                const message = res.data.message;
                                let data = new FormData();
                                data.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
                                data.append('language', this.state.langKey);
                                axios({
                                    method: 'post',
                                    url: this.state.api_url + 'webprofile',
                                    data: data,
                                    config: { headers: { 'Content-Type': 'multipart/form-data' } }
                                }).then(res => {
                                    if (res.data.status !== false) {
                                        this.setState({
                                            successMessage: 'Uploaded Successfully',
                                            suc_cls: 'successMsg floatingAlerts1'
                                        });
                                        setTimeout(() => {
                                            this.setState({
                                                suc_cls: 'successMsghide'
                                            });
                                            window.location.reload();
                                        }, 3000);
                                    } else {
                                        this.props.history.push("/");
                                    }
                                }).catch(error => {
                                    this.props.history.push("/");
                                });
                            });
                            this.setState({
                                showLoader: 0,
                            });
                        } else {
                            this.setState({
                                showLoader: 1,
                            });
                            this.setState({
                                successMessage: res.data.message,
                                suc_cls: 'successMsg floatingAlerts1'
                            });
                            setTimeout(() => {
                                this.setState({
                                    suc_cls: 'successMsghide'
                                });
                                window.location.reload();
                            }, 3000);
                        }
                    });
                // }
            };
            reader.readAsDataURL(file);
        }
    };

    onDeleteimage(item) {
        var image_url = item;
        var delete_image = new FormData();
        delete_image.set('delete_image', image_url);
        delete_image.set('language', this.state.langKey);
        delete_image.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
        // if (this.state.showLoader === 0) {
            axios({
                method: 'post',
                url: this.state.api_url + 'websetprofile',
                data: delete_image,
                config: { headers: { 'Content-Type': 'multipart/form-data' } }
            }).then(res => {
                const status = res.data.status;
                if (status !== "false") {
                    // this.setState({
                    //     successMessage: res.data.message,  
                    //     suc_cls: 'successMsg floatingAlerts1',
                    // });
                    setTimeout(() => {
                        this.setState({
                            successMessage: res.data.message,
                            suc_cls: 'successMsg floatingAlerts1',
                        });
                        // this.setState({
                        //     // suc_cls: 'successMsghide'
                        // });
                        window.location.reload();
                    }, 3000);
                }
            });
        // }
    }

    onFirstlook(item) {
        var first_look = new FormData();
        first_look.set('user_image', item);
        first_look.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
        first_look.set('language', this.state.langKey);
        axios({
            method: 'post',
            url: this.state.api_url + 'websetfirstlook',
            data: first_look,
            config: { headers: { 'Content-Type': 'multipart/form-data' } }
        }).then(res => {
            if (res.data.status !== false) {
                let data = new FormData();
                data.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
                data.append('language', this.state.langKey);
                axios({
                    method: 'post',
                    url: this.state.api_url + 'webprofile',
                    data: data,
                    config: { headers: { 'Content-Type': 'multipart/form-data' } }
                }).then(res => {
                    if (res.data.status !== false) {
                        const user_details = res.data.result;
                        this.setState({
                            user_details: user_details,
                            image: user_details.imagess,
                            imagess: user_details.imagess,
                        });
                        window.location.reload();
                    } else {
                        this.props.history.push("/");
                    }
                }).catch(error => {
                    this.props.history.push("/");
                });
            } else {
                this.props.history.push("/");
            }
        }).catch(error => {
            this.props.history.push("/");
        })
    }

    render() {
        const { previewImage } = this.state;
        return (
            <>
                <section className='common_layout'>
                    <div className='header_layout'>
                        <div className='back_div'>
                            <Link to='/profile'>
                                <img src={back} alt="img" />
                            </Link>
                        </div>
                        <div className='header_title margin_auto'>
                            <h4><Trans i18nKey="Edit Photo">Edit Photo</Trans></h4>
                        </div>
                        <div className='whole_information'>
                            {this.state.successMessage && (
                                <div className={this.state.suc_cls}>
                                    {this.state.successMessage}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className='mt_2'>
                        <Container>
                            <Row className=''>
                                <div className={this.state.suc_msg}>{this.state.errors.uploadimage}</div>
                                <Col md={9} className="margin_xauto">
                                    {
                                        this.state.imagess.map((item, index) => (
                                            index === 0 ? (
                                                <div key={index} className="edit_banner">
                                                    <img src={item} alt="img" className='edit_banner_img' />
                                                </div>
                                            ) : null
                                        ))
                                    }
                                    <div className='edit_cards'>
                                        {
                                            this.state.imagess.map((item, index) => (
                                                index > 0 && index <= 4 ? (
                                                    <div key={index} className="edit_Subcard">
                                                        <img src={item} alt="img" className='edit_Subcardimg' />
                                                        <div className='editdropdown'>
                                                            <Dropdown className='editdropdowndiv'>
                                                                <Dropdown.Toggle id="dropdown-basic">
                                                                    <img src={more} alt="img" />
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item onClick={() => this.onFirstlook(item)}><Trans i18nKey="First look">First look</Trans></Dropdown.Item>
                                                                    <Dropdown.Item onClick={() => this.onDeleteimage(item)}><Trans i18nKey="Delete">Delete</Trans></Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </div>
                                                ) : null
                                            ))
                                        }
                                        {
                                            this.state.imagess.length < 5 ? (this.state.showLoader === 1 ? (<div className='loader-lottiee'>
                                            <Lottie animationData={(this.state.showLoader === 1) ? loaderjson : ''} className='' />
                                            </div>) : previewImage ? (<div className='edit_Subcard'>
                                                    <img src={previewImage} alt="Preview" className='edit_Subcardimg' />
                                                </div>) : (<div className='edit_upload'>
                                                    <img src={upload} alt="Upload Icon" />
                                                    <input type="file" accept="image/*" onChange={this.handleFileChange} style={{ display: 'none' }} ref={this.fileInput} />
                                                    <Button onClick={() => this.fileInput.current.click()}><Trans i18nKey="Choose File">Choose File</Trans></Button>
                                                </div>)) : ''
                                        }
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </section>

            </>
        );
    }
}

export default withTranslation("translations")(withRouter(EditPhoto));
